/*
    Plugin Name: Bjorn Build A Box
    Description: Bjorn Build A Box.
*/
; (function($, window, document, undefined) {
    "use strict";
    let plugin;
    const PLUGIN_NAME = 'bjornBuildABox';

    function Plugin(element, options) {
        this._element = element;
        this._pluginName = PLUGIN_NAME;
        this._defaults = $.fn[PLUGIN_NAME].defaults;
        this._settings = $.extend({}, this._defaults, options);
        this._flavors = [];
        this._init();
    }
    $.extend(Plugin.prototype, {
        _init: function() {
            plugin = this;
            this._build();
            this._bindEvents();
        },
        _build: function() {
            this.$_element = $(this._element);
            $('.action button[name=add]', this._settings.formSelector).prop('disabled', false);
        },
        _bindEvents: function() {
            $(this._settings.flavorSelector, plugin.$_element).on('click' + '.' + plugin._pluginName, function(e) {
                plugin._flavorClicked.call(plugin, e, $(this));
            });
            plugin.$_element.on('click' + '.' + plugin._pluginName, this._settings.flavorRemoveSelector, function(e) {
                plugin._flavorRemoveClicked.call(plugin, e, $(this));
            });
            plugin.$_element.on('click' + '.' + plugin._pluginName, this._settings.clearAllSelector, function(e) {
                plugin._clearAllFlavors.call(plugin, e, $(this));
            });
            plugin.$_element.on('change' + '.' + plugin._pluginName, this._settings.mySelect, function(e) {
                plugin._mySelectChange.call(plugin, e, $(this));
            });
            $(this._settings.formSelector, plugin.$_element).on('submit' + '.' + plugin._pluginName, function(e) {
                plugin._onSubmit.call(plugin, e);
            });
            $(window).bind("load", () => {
                plugin._redrawBuildabox.call(plugin);
            });
        },
        _unbindEvents: function() {
            this.$_element.off('.' + this._pluginName);
        },
        _destroy: function() {
            this._unbindEvents();
            this.$_element.removeData();
        },
        _flavorClicked: function(e, el) {
            if (this._currentCounts().count >= this._settings.boxSizes[this._currentVariantPrefix()]) {
                return;
            }
            $('.flavor:empty:first', '#buildabox').append(el.html()).data('flavor', el.data('flavor'));
            this._addFlavor(el.data('flavor'));
            this._callback();
        },
        _flavorRemoveClicked: function(e, el) {
            if (el.data('flavor')) {
                this._deleteFlavor(el.data('flavor'));
                el.removeData('flavor');
            }
            el.closest('.flavor').empty();
            this._callback();
        },
        _mySelectChange: function(e, el) {
            if (e && e.target.id != 'mySelect') {
                return false;
            }
            let baseVariant = [$(this._settings.mySelectSelector, this._settings.formSelector).val(), 0].join('_');
            $(`option[data-buildabox-variant=${baseVariant}]`, this._settings.productVariantSelector).prop('selected', true);
            $(this._settings.productVariantSelector, this._settings.formSelector)[0].dispatchEvent(new Event('change'));
            plugin._clearAllFlavors.call(plugin);
            plugin._redrawBuildabox.call(plugin);
        },
        _onSubmit: function(e) {
            if (this._currentCounts().count !== this._currentCounts().max) {
                $(`.myAlert[id^=myAlert_]`, this._settings.formSelector).remove();
                e.preventDefault();
                let selectedRemaining = this._currentCounts().max - this._currentCounts().count;
                let slotString = (selectedRemaining == 1 ? 'slot' : 'slots');
                let alertMsg = `Please fill the remaining <b>${selectedRemaining}</b> ${(selectedRemaining==1?'slot':'slots')} before adding your box to the qart.`;
                let seed = performance.now().toString().split('.').join("");
                $('.action', this._settings.formSelector).before(`<div id='myAlert_${seed}' class='myAlert'>${alertMsg}</div>`);
                setTimeout(() => {
                    let myAlert = $(`#myAlert_${seed}`, this._settings.formSelector);
                    myAlert.fadeOut('slow', function() {
                        myAlert.remove();
                    });
                }, 2000);
                return false;
            }
            this._callback();
        },
        _redrawBuildabox: function() {
            $('input[type=hidden].flavor-property', this._settings.formSelector).remove();
            $('#buildabox .flavor').remove();
        	$('#buildabox').append(new Array(this._settings.boxSizes[this._currentVariantPrefix()]+1).join('<div class="flavor"></div>'));
            $('.flavors:visible', '.product-section').hide();
            $(`.flavors.${this._currentVariantPrefix().split('_').pop()}:hidden`, '.product-section').show();
            $('#buildabox').removeClass('full_3oz half_3oz full_1oz half_1oz').addClass(this._currentVariantPrefix());
            this._callback();
        },
        _flavorCounts: function() {
            let a = [];
            var self = this;
            $.each(this._flavors.filter((value, index, self) => {
                return self.indexOf(value) === index;
            }).sort(), function(i, f) {
                var v = self._flavors.filter(flavor => {
                    if (flavor == f) {
                        return true;
                    }
                    return false;
                }).length;
                a.push(`<span>${f.charAt(0).toUpperCase() + f.slice(1).toLowerCase()}&nbsp;(${v})</span>`);
            });
            return a.join(' ');
        },
        _currentCounts: function() {
            return {
                'count': this._flavors.length,
                'max': this._settings.boxSizes[this._currentVariantPrefix()]
            };
        },
        _refreshCounts: function() {
            $('.flavor-counts', this._settings.counterSelector).html(this._flavorCounts());
            $('.count', this._settings.counterSelector).html(this._currentCounts().count);
            $('.max', this._settings.counterSelector).html(this._currentCounts().max);
        },
        _adjustSurcharge: function() {
            let earths = this._flavors.filter(flavor => {
                if (flavor == 'earth') {
                    return true;
                }
                return false;
            }).length;
            let surchargeVariant = [this._currentVariantPrefix(), earths].join('_');
            $(`option[data-buildabox-variant=${surchargeVariant}]`, this._settings.productVariantSelector).prop('selected', true);
            $(this._settings.productVariantSelector, this._settings.formSelector)[0].dispatchEvent(new Event('change'));
        },
        _currentVariant: function() {
            return $('option:selected', this._settings.productVariantSelector).data('buildabox-variant');
        },
        _currentVariantPrefix: function() {
            return $('option:selected', this._settings.productVariantSelector).data('buildabox-variant-prefix');
        },
        _clearAllFlavors: function() {
            this._flavors = [];
            $('.flavor', '#buildabox').empty();
            this._adjustSurcharge();
            this._callback();
        },
        _addFlavor: function(f) {
            this._flavors.push(this._prepareFlavor(f));
        },
        _deleteFlavor: function(f) {
            var i = this._flavors.map(e => e.trim().toLowerCase()).lastIndexOf(this._prepareFlavor(f));
            if (i > -1) {
                this._flavors.splice(i, 1);
            }
        },
        _refreshProperties: function() {
            var self = this;
            
            // Define flavor hierarchy order
            const flavorOrder3oz = ['classic', 'spicy', 'cloudy', 'maple', 'earth'];
            const flavorOrder1oz = ['classic', 'spicy', 'cloudy'];
            
            // Determine if this is 1oz or 3oz based on variant
            const is1oz = this._currentVariantPrefix().includes('1oz');
            const flavorOrder = is1oz ? flavorOrder1oz : flavorOrder3oz;
            
            // Remove all old flavor properties
            $('.flavor-property', this._settings.formSelector).remove();
            
            // Get unique flavors
            const uniqueFlavors = this._flavors.filter((value, index, self) => {
                return self.indexOf(value) === index;
            });
            
            // Sort by hierarchy order
            const sortedFlavors = uniqueFlavors.sort((a, b) => {
                const indexA = flavorOrder.indexOf(a);
                const indexB = flavorOrder.indexOf(b);
                if (indexA === -1) return 1;
                if (indexB === -1) return -1;
                return indexA - indexB;
            });
            
            // Create properties in sorted order
            sortedFlavors.forEach(function(f) {
                var count = self._flavors.filter(flavor => flavor === f).length;
                var property_value = `${f.charAt(0).toUpperCase() + f.slice(1).toLowerCase()} x ${count}`;
                $(self._settings.formSelector).append(`<input type="hidden" class="flavor-property" name="properties[flavors][]" value="${property_value}" />`);
            });
        },
        _prepareFlavor: function(str) {
            return str.trim().toLowerCase();
        },
        _callback: function() {
            let onComplete = this._settings.onComplete;
            if (typeof onComplete === "function") {
                onComplete(this._element);
            }
            this._refreshProperties();
            this._adjustSurcharge();
            this._refreshCounts();
        }
    });
    $.fn[PLUGIN_NAME] = function(options) {
        this.each(function() {
            if (!$.data(this, "plugin_" + PLUGIN_NAME)) {
                $.data(this, "plugin_" + PLUGIN_NAME, new Plugin(this, options));
            }
        });
        return this;
    };

    $.fn[PLUGIN_NAME].defaults = {
        boxSizes: {
            'full_3oz': 12,
            'half_3oz': 6,
            'full_1oz': 30,
            'half_1oz': 15
        },
        quantitySelector: '#Quantity',
        formSelector: 'form[id^="product_form_"]',
        flavorSelector: '.product-section .flavors .flavor',
        flavorRemoveSelector: '#buildabox .flavor',
        productVariantSelector: '#productVariantSelect',
        mySelectSelector: '#mySelect',
        counterSelector: '#selection-counter',
        clearAllSelector: '#clearAllFlavors',
        onComplete: null
    };
})(jQuery, window, document);